import { Config } from '../entities/config';
import { Database } from './database';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { SearchableItem } from '../pages/search/search';
import { Port } from '../entities/port';

@Injectable()
export class Shared {

    public constructor(
        private database: Database,
        private events: Events,
    ) {
    }

    get(key: any): any {
        Shared.validKey(key);
        if (this[key]) return this[key];
        return null;
    }

    set(key: any, value: any): any {
        Shared.validKey(key);
        if (typeof value === 'undefined') throw new TypeError('Value should not be undefined');
        this[key] = value;
        return value;
    }

    unset(key: string) {
        Shared.validKey(key);
        delete this[key];
    }

    private static validKey(key: any) {
        if (typeof key !== 'string')
            throw new TypeError('Key should be a string');
        if (key.length === 0)
            throw new Error('Key is empty');
    }

    setConfig(configKey: string, configValue: any): Promise<Config> {
        return new Promise<Config>((resolve, reject) => {
            this.getConfig(configKey).then((config: Config) => {
                if (config === undefined) {
                    config = new Config();
                    config.key = configKey;
                }
                config.value = configValue;
                this.database.config().save(config).then(() => {
                    resolve(config);
                }, (error: any) => {
                    reject(error);
                });
            }, (error) => {
                let config: Config = Config.createFromObject({
                    key: 'apiToken',
                    value: configValue,
                });
                this.database.config().save(config).then(() => {
                    resolve(config);
                }, (error: any) => {
                    reject(error);
                });
            });
        });
    }

    getConfig(configKey: string): Promise<Config> {
        return this.database.config().findOne({key: configKey});
    }

    setAndStore(configKey: string, configValue: any): Promise<Config> {
        this.set(configKey, configValue);
        return this.setConfig(configKey, configValue);
    }

    unsetAndRemove(configKey: string): Promise<any> {
        this.unset(configKey);
        return this.database.config().delete({key: configKey});
    }

    async getConfigAndSetShared(configKey: string) {
        let config: Config = await this.getConfig(configKey);
        if (config === undefined) return;
        this.set(configKey, config.value);
        return config;
    }

    setSyncStatus(syncStatus: Config): Promise<Config> {
        return new Promise<Config>((resolve, reject) => {
            if (syncStatus === undefined) reject();
            this.setConfig(syncStatus.key, syncStatus.value).then((syncStatus: Config) => {
                this.events.publish('sync:status', syncStatus);
                resolve(syncStatus);
            }, () => {
                reject();
            });
        });
    }

    static convertPortsToSearchableItems(ports: Port[]): SearchableItem[] {
        let items: SearchableItem[] = [];
        for (let port of ports) {
            let item: SearchableItem = {
                id: port.id,
                text: port.name,
            };
            items.push(item);
        }
        return items;
    }

    static convertItemToPort(item: SearchableItem, ports: Port[]) {
        let port: Port;
        for (let aPort of ports) {
            if (aPort.id === item.id) port = aPort;
        }
        return port;
    }

    static ucwords (str) {
        return (str + '')
            .replace(/^(.)|\s+(.)/g, function ($1) {
                return $1.toUpperCase()
            })
    }
}



// WEBPACK FOOTER //
// ./src/providers/shared.ts